import type { ReactElement } from "react";
import * as S from "./style";
import { observer } from "mobx-react-lite";
import { Icon } from "@smartsuite/react-ui/lib";
import { Colors } from "@smartsuite/types";

export const StatusBadge = observer<{
  status: "error" | "success";
  title: string;
  subTitle?: string;
}>(({ status, title, subTitle }): ReactElement => {
  const iconName = status === "error" ? "important-lined" : "check-circle";
  const iconColor = status === "error" ? Colors.bRed : Colors.bGreen;
  const Wrapper = status === "error" ? S.ErrorWrapper : S.SuccessWrapper;

  return (
    <Wrapper>
      <S.IconWrapper>
        <Icon name={iconName} color={iconColor} />
      </S.IconWrapper>
      <span>
        <S.TitleWrapper>
          <span>{title}</span>
        </S.TitleWrapper>
        {subTitle && (
          <S.SubTitleWrapper>
            <span>{subTitle}</span>
          </S.SubTitleWrapper>
        )}
      </span>
    </Wrapper>
  );
});
